// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UwKq","input":"styles_input__Pj30b"};